import { ChartLineDataItem } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { buildDailyChartData } from '../../vehicle-fingerprint.utils';

export function buildElectricalSignatureData(context: VehicleFingerprintContext): ChartLineDataItem[] {
  return buildDailyChartData(context.dailyPower || [], context.dates || [], row => {
    const value = row.fElectricalPowerMean;
    return row.bHasValidElectrical && typeof value === 'number' && Number.isFinite(value) ? value : null;
  });
}
